'use client';

import { transferCart } from '@lib/data/customer';
import { Button } from '@modules/common/components/button';
import { InfoCircle } from '@modules/common/icons';
import { useState } from 'react';
import type { CartMismatchVM } from 'types/view-models';

function CartMismatchBanner({ cartCustomerId }: CartMismatchVM) {
  const [isPending, setIsPending] = useState(false);
  const [actionText, setActionText] = useState('Try again');

  if (cartCustomerId) {
    return null;
  }

  const handleSubmit = async () => {
    try {
      setIsPending(true);
      setActionText('Transferring…');

      await transferCart();
    } catch {
      setActionText('Try again');
      setIsPending(false);
    }
  };

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="sticky h-[60px] top-0 z-[60] flex items-center justify-center desktop:p-4 p-2 text-center bg-orange-300 desktop:gap-2 gap-1 text-sm text-orange-800"
    >
      <div className="flex flex-col desktop:flex-row desktop:gap-2 gap-1 items-center">
        <span className="flex items-center gap-2">
          <InfoCircle
            className="text-orange-500 w-5 h-5 shrink-0"
            aria-hidden="true"
          />
          We couldn't move your guest basket to your account. Try again to keep
          your items.
        </span>

        <span className="hidden desktop:block" aria-hidden="true">
          ·
        </span>

        <Button
          variant="ghost"
          className="hover:bg-transparent active:bg-transparent focus:bg-transparent disabled:text-orange-500 text-orange-950 p-0 bg-transparent"
          disabled={isPending}
          onClick={handleSubmit}
        >
          {actionText}
        </Button>
      </div>
    </div>
  );
}

export default CartMismatchBanner;
